/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_FailedInputs */

const vi_einvoice_failed = /** @type {(inputs: Einvoice_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất HĐĐT thất bại`)
};

/**

* @param {Einvoice_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_failed = /** @type {((inputs?: Einvoice_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_failed(inputs)
});